<template>
    <div
        class="introduction"
        @click="workOut()"
    >
        <audio
            ref="music"
            loop
            hidden="true"
            preload="auto"
            src="/static/assets/audio/birthday.mp3"
        >
        </audio>
        <div
            class="ribbon-position"
            :class="item.ribbonName"
            v-show="isTouch"
            v-for="item in arr"
            :style="{left:item.left}"
        >
            <!--<div :class="item.ribbonName">-->
            <!--</div>-->
        </div>
        <i class="music-icon"></i>
        <div class="happy-birthday">
            <img
                src="../../assets/img/happyBirthday.png"
                alt=""
            >
        </div>
        <div class="copy">
            <p><i></i> &nbsp;
                <Organization :name="userInfo.realName" type="userName" :openid="userInfo.memberKeyRaw" :useOpenData="userInfo.useOpenData" ></Organization>
            </p>
            <img
                src="../../assets/img/happy-birthday-text.png"
                alt=""
            >
        </div>
        <div class="cake">
            <img
                class="common-fire fire"
                :class="{'work-out':isTouch}"
                src="../../assets/img/fire.png"
                alt=""
            >
            <img
                class="common-fire smoke"
                src="../../assets/img/smoke.png"
                alt=""
                v-show="isTouch"
            >
            <img
                src="../../assets/img/introduction-cake.png"
                alt=""
            >
        </div>
        <div class="introduction-footer">
            <div
                class="box"
                v-show="!isTouch"
            >
                <img
                    class="four"
                    src="../../assets/img/intro-tip.png"
                    alt=""
                >
            </div>
        </div>

        <div
            class="toWishModel"
            v-show="showModel"
        >
            <div class="shadow">

            </div>
            <div
                class="model"
                @click="GotoPersonal()"
            >
                <div class="top">
                    <img
                        class="model-cake-fire left"
                        src="../../assets/img/model-cake-fire.png"
                        alt=""
                    >
                    <img
                        class="model-cake-fire middle"
                        src="../../assets/img/model-cake-fire.png"
                        alt=""
                    >
                    <img
                        class="model-cake-fire right"
                        src="../../assets/img/model-cake-fire.png"
                        alt=""
                    >
                    <img
                        class="bgi"
                        src="../../assets/img/model-bgi.png"
                        alt=""
                    >
                    <p>生日快乐</p>
                    <img
                        src="../../assets/img/model-cake.png"
                        alt=""
                    >
                </div>
                <button><i class="model-cake-icon"></i>开启我的生日祝福</button>
            </div>
        </div>
        <home :ishome=0></home>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import home from "../common/home.vue";
import Organization from "@/components/common/organization.vue";
export default {
    data() {
        return {
            loading: true,
            isTouch: false,
            showModel: false,
            left1: "",
            time: "",
            intTime: "",
            userName: "",
            corpId: "",
            num: 1, // 记录点击数
            arr: [{}]
        };
    },
    components: {
        home,
        Organization,
    },
    computed: {
        ...mapGetters({
            userInfo: "getUserInfo",
        }),
    },
    created() {
        this.corpId = this.$route.query.corpId;
        let _this = this;
        this.$nextTick(function () {
            _this.audioAutoPlay();

            document.body.addEventListener(
                "touchmove",
                _this.preHandler,
                false
            );
        });
    },
    beforeDestroy() {
        clearInterval(this.time);
        document.body.removeEventListener("touchmove", this.preHandler, false);
    },
    beforeMount() {
        
    },
    methods: {
        preHandler(e) {
            e.preventDefault();
        },
        GotoPersonal: function () {
            this.$router.push({
                path: "/birthday/personal",
                query: {
                    corpId: this.corpId,
                },
            });
        },
        audioAutoPlay() {
            let _this = this;
            let audio = _this.$refs.music;
            audio.play();
            document.addEventListener(
                "WeixinJSBridgeReady",
                function () {
                    audio.play();
                },
                false
            );
        },
        workOut: function () {
            if (this.num === 1) {
                let that = this;
                that.$refs.music.play();
                that.isTouch = true;
                that.time = setInterval(function () {
                    let nameNumber1 = Math.floor(Math.random() * 24);
                    console.log(nameNumber1);
                    let nameNumber2 = Math.floor(Math.random() * 24);
                    let nameNumber3 = () => Math.floor(Math.random() * 80);
                    let nameNumber4 = Math.floor(Math.random() * 24);
                    that.arr.push(
                        {
                            ribbonName: "ribbon-" + nameNumber1,
                            left: nameNumber3() + "%",
                        },
                        {
                            ribbonName: "ribbon-" + nameNumber2,
                            left: nameNumber3() + "%",
                        }
                    );
                }, 1000);
                setTimeout(function () {
                    clearInterval(that.time);
                }, 5000);
                setTimeout(function () {
                    that.showModel = true;
                }, 15000);
                ++this.num;
            }
        },
    },
};
</script>